import React, { useState } from 'react';
import * as Yup from 'yup';
import { Field, Form, Formik } from 'formik';
import { Box, Grid, Typography } from '@material-ui/core';
import makeStyles from '@material-ui/core/styles/makeStyles';
import LinearProgress from '@material-ui/core/LinearProgress';
import Button from '@material-ui/core/Button';
import { useSnackbar } from 'notistack';
import { useDictionaryApi } from '../../api/dictionary';
import PasswordInput from '../../components/atoms/PasswordInput/PasswordInput';

interface PasswordForm {
    oldPassword: string;
    password: string;
    passwordConfirm: string;
}

function initPasswordForm() {
    return {
        oldPassword: '',
        password: '',
        passwordConfirm: '',
    };
}

const ResetPassword = () => {
    const classes = useStyles();
    const { enqueueSnackbar } = useSnackbar();
    const [item, setItem] = useState<PasswordForm>(initPasswordForm());
    const { put } = useDictionaryApi<any>('/users/current/change-pwd');

    const schema = () =>
        Yup.object().shape({
            oldPassword: Yup.string().required('Введите текущий пароль'),
            password: Yup.string().when(
                'id',
                (id: number | undefined, schema: Yup.StringSchema) => {
                    if (!id) {
                        return schema.required('Введите новый пароль');
                    }
                }
            ),
            passwordConfirm: Yup.string()
                .when('id', (id: number | undefined, schema: Yup.StringSchema) => {
                    if (!id) {
                        return schema.required('Повторите новый пароль');
                    }
                })
                .oneOf([Yup.ref('password'), null], 'Введенный пароль не совпадает'),
        });

    return (
        <Box position="relative">
            <Formik
                enableReinitialize={true}
                initialValues={item}
                validationSchema={schema()}
                onSubmit={(values, { setSubmitting }) => {
                    put({ old_password: values.oldPassword, new_password: values.password })
                        .then(() => {
                            enqueueSnackbar('Пароль успешно изменен', {
                                variant: 'success',
                            });
                            setItem(values);
                            setItem(initPasswordForm());
                        })
                        .catch(() => {
                            enqueueSnackbar('Ошибка при сохранении данных', {
                                variant: 'error',
                            });
                        })
                        .finally(() => {
                            setSubmitting(false);
                        });
                }}
            >
                {({ isSubmitting, submitForm }) => (
                    <Form className={classes.root}>
                        <Grid
                            className={classes.container}
                            container
                            item
                            spacing={4}
                            xs={12}
                            md={10}
                            xl={8}
                            lg={8}
                        >
                            <Typography variant="h3" className={classes.title}>
                                Сменить пароль
                            </Typography>
                            <Grid item xs={6}>
                                <Field
                                    component={PasswordInput}
                                    className={classes.mt5}
                                    inputProps={{
                                        autoComplete: 'new-password',
                                        form: {
                                            autoComplete: 'off',
                                        },
                                    }}
                                    name="oldPassword"
                                    type="password"
                                    label="Текущий пароль"
                                />
                                <Field
                                    component={PasswordInput}
                                    className={classes.mt5}
                                    inputProps={{
                                        autoComplete: 'new-password',
                                        form: {
                                            autoComplete: 'off',
                                        },
                                    }}
                                    name="password"
                                    type="password"
                                    label="Новый пароль"
                                />
                                <Field
                                    component={PasswordInput}
                                    className={classes.mt5}
                                    name="passwordConfirm"
                                    type="password"
                                    inputProps={{
                                        autoComplete: 'new-password',
                                        form: {
                                            autoComplete: 'off',
                                        },
                                    }}
                                    label="Повторите новый пароль"
                                />
                                <div className={classes.progress}>
                                    {isSubmitting && <LinearProgress />}
                                </div>
                                <Button
                                    disabled={isSubmitting}
                                    onClick={submitForm}
                                    variant="contained"
                                    color="primary"
                                >
                                    Сохранить
                                </Button>
                            </Grid>
                        </Grid>
                    </Form>
                )}
            </Formik>
        </Box>
    );
};

const useStyles = makeStyles((theme) => ({
    root: {},
    mt5: {
        marginBottom: theme.spacing(3),
        width: '100%',
    },
    checkList: {
        marginTop: theme.spacing(6),
    },
    progress: {
        height: '4px',
        width: '100%',
        marginBottom: '20px',
    },
    container: {
        position: 'relative',
    },
    title: {
        width: '100%',
        paddingLeft: theme.spacing(2),
    },
}));

export default ResetPassword;
